import { useEffect, useState } from 'react';
import { PublicProduct, publicStorefrontApi } from '../../services/storefrontService';

/** Lädt den öffentlichen Katalog einer Storefront. */
export function useStorefrontProducts(slug: string) {
    const [products, setProducts] = useState<PublicProduct[] | null>(null);
    const [error, setError] = useState(false);
    useEffect(() => {
        let cancelled = false;
        setProducts(null);
        setError(false);
        publicStorefrontApi
            .products(slug)
            .then((d) => !cancelled && setProducts(d.products))
            .catch(() => !cancelled && setError(true));
        return () => {
            cancelled = true;
        };
    }, [slug]);
    return { products, error };
}
